import {create, remove} from "@/api/rest";

const attachment = {
  saveAttachment: async (data) =>
      await create('/attachment', data,  {"Content-Type": "multipart/form-data"}),
  deleteAttachment: async (url) => await remove(url),
};

export default attachment;